module.exports = __webpack_public_path__ + "img/face-kiss-beam.b245ab59.svg";